<template>
    <div class="input-control">
        <input :name="name" :spellcheck="spellcheck" @input="onInput" ref="input" :placeholder="placeholder"
               :autocomplete="autocomplete"
               @blur="onInputBlurred" @keydown.enter="onKeydownEnter">
    </div>
</template>

<script>
    import InputControlBase from "@/InputControls/InputControlBase";

    export default {
        name: "TextField",
        mixins: [InputControlBase],
        props: {
            spellcheck: String,
            valueTransformer: Function,
            valueFormatter: Function,
            valueToStringParser: Function,
            blurWhenEntered: {
                default: true
            },
            placeholder: String,
            autocomplete: String,
        },
        mounted() {
            this.setInputValue(this.value);
        },
        methods: {
            onKeydownEnter() {
                if (this.blurWhenEntered) {
                    this.$refs.input.blur();
                }
                this.$emit('keydownEnter')
            },
            repaintUI() {
                this.$refs.input.value = this.getFormattedValue(this.getStringValue(), '');
            },
            onInput(event) {
                const stringValue = event.currentTarget.value;
                event.currentTarget.value = this.getFormattedValue(stringValue, stringValue);

                this.value = this.getTransformedValue(stringValue, this.value);

                if (document.activeElement !== this.$refs.input) {
                    this.$refs.input.value = this.getFormattedValue(stringValue, this.getFormattedValue(this.getStringValue(), this.getStringValue()))
                }
            },
            setInputValue(value) {
                if (typeof value === 'undefined' || value === null) {
                    value = '';
                } else if (this.valueToStringParser) {
                    value = this.valueToStringParser(value);
                } else {
                    value = String(value);
                }

                this.value = this.getTransformedValue(value, null);
                this.repaintUI();
            },
            focus() {
                this.$refs.input.focus();
            },
            getStringValue() {
                if (this.value === null) {
                    return '';
                }

                if (this.valueToStringParser) {
                    return this.valueToStringParser(this.value);
                }

                return String(this.value);
            },
            onInputBlurred() {
                if (this.value !== null && this.value.constructor === String) {
                    this.value = this.value.trim();
                }
                this.repaintUI();
            },
            getTransformedValue(stringValue, fallbackValue) {
                if (!this.valueTransformer) {
                    return stringValue;
                }
                return this.valueTransformer(stringValue, fallbackValue);
            },
            getFormattedValue(stringValue, fallbackValue) {
                if (!this.valueFormatter) {
                    return stringValue;
                }
                return this.valueFormatter(stringValue, fallbackValue);
            }
        },
        data() {
            return {

            }
        },
    }
</script>

<style scoped lang="scss">
    @import "input-controls";

    input {
        width: 100%;
    }
</style>
